import React from 'react';

// The HTML in a message is written by an agent or comes from a flow's settings, so it can
// carry a malformed tag like `<br\>`. The browser builds an element named `br\` without
// complaining, but a backslash is not legal in an XML name — and anything that serializes
// the DOM to XML (a screenshot, an export) then produces a document the browser cannot
// decode. Such a tag means nothing, so it is unwrapped and its content kept.
const VALID_TAG_NAME = /^[A-Za-z_][A-Za-z0-9._-]*$/;

const unwrapInvalidTags = (container) => {
  for (const element of [...container.querySelectorAll('*')])
    if (!VALID_TAG_NAME.test(element.tagName))
      element.replaceWith(...element.childNodes);
}

const renderHTML = (content) => {

  const container = document.createElement('div');
  container.innerHTML = content;

  const elementsWithDataId = container.querySelectorAll('[data-id]');
  elementsWithDataId.forEach(el => {
    const textNode = document.createTextNode(el.getAttribute('data-id'));
    el.replaceWith(textNode);
  });

  let flattenedHTML = container.innerHTML;
  flattenedHTML = flattenedHTML.replace(/&gt;/g, '>').replace(/&lt;/g, '<');

  // Re-parsed after unescaping on purpose: that step turns escaped text back into real
  // markup, which is exactly where a malformed tag slips into the document.
  container.innerHTML = flattenedHTML;
  unwrapInvalidTags(container);

  return <span dangerouslySetInnerHTML={{ __html: container.innerHTML }} />;

}

export { renderHTML };
